const enum BastionType {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
  CPU_OPTIMIZED = 'CPU_OPTIMIZED',
  LIMITED_NETWORK = 'LIMITED_NETWORK',
}

export default BastionType;
